module.exports = __webpack_public_path__ + "img/link-icon.b20a53fb.svg";